import { ConsultationsForConsultant } from '../containers/ConsultationsForConsultant/index'

export const ConsultationForConsultantPage = ({type, setType}) => (
    <ConsultationsForConsultant type={type} setType={setType} />
)